// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 163) return "static/css/163.1d376cbdc4e0c048253f.lib.css";
	if (chunkId === 943) return "static/css/943.1e765d21c092966d7d96.css";
	// return url for filenames based on template
	return undefined;
};